import { render, staticRenderFns } from "./ViewUploadLink.vue?vue&type=template&id=5734d4c2&"
import script from "./ViewUploadLink.vue?vue&type=script&lang=js&"
export * from "./ViewUploadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports